import { ixlBranding } from "@resourcehub/resourcehub-assets";

export default ({ strings }) => ({
    visible: true,
    image: {
        asset_static: ixlBranding.ixlLogoSvg,
        height: "45px",
        width: "110px",
        alt: strings.footer_meta_copyright_alt
    },
    link: {
        destination: "https://www.ixl.com/",
        external: false,
        new_window: false
    }
});
